import { render, staticRenderFns } from "./fission.vue?vue&type=template&id=fddf0b8a&scoped=true&"
import script from "./fission.vue?vue&type=script&lang=js&"
export * from "./fission.vue?vue&type=script&lang=js&"
import style0 from "./fission.vue?vue&type=style&index=0&id=fddf0b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddf0b8a",
  null
  
)

export default component.exports